import React from 'react'
import SalesStatisticOne from './child/SalesStatisticOne';
import TotalSubscriberOne from './child/TotalSubscriberOne';
import UsersOverviewOne from './child/UsersOverviewOne';
import LatestRegisteredOne from './child/LatestRegisteredOne';
import TopPerformerOne from './child/TopPerformerOne';
// import TopCountries from './child/TopCountries';
// import GeneratedContent from './child/GeneratedContent';
import UnitCountOne from './child/UnitCountOne';
import TopInstructorsOne from './child/TopInstructorsOne';
import TopInstructorsTwo from './child/TopInstructorsTwo';

const DashBoardLayerOne = () => {

    return (
        <>
            {/* UnitCountOne */}
            <UnitCountOne />

            <section className="row gy-4 mt-1">

                {/* SalesStatisticOne */}
                <SalesStatisticOne />

                {/* TotalSubscriberOne */}
                <TotalSubscriberOne />

                {/* UsersOverviewOne */}
                <UsersOverviewOne />

                {/* LatestRegisteredOne */}
                <LatestRegisteredOne />

                {/* TopPerformerOne */}
                <TopPerformerOne />

                {/* TopInstructorOne Left */}
                <TopInstructorsOne title='Recent Reviews & Ratings' />

                {/* TopInstructorOne Right */}
                <TopInstructorsTwo title='Highest Reviews & Ratings' />

                {/* TopCountries */}
                {/* <TopCountries /> */}

                {/* GeneratedContent */}
                {/* <GeneratedContent /> */}

            </section>
        </>


    )
}

export default DashBoardLayerOne